export default __webpack_public_path__ + "static/media/Emblem_Bronze.0917da69.webp";